var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "153px",
    height: "153px",
    viewBox: "0 0 153 153",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F19585D1-F0C8-4A2E-9ABA-796270916011") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GloepidOne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-details",
    transform: "translate(-695.000000, -534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(695.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Duplicate-control",
    points: "0 0 165 0 165 165 0 165"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 2.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 18.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 51.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 68.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 101.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 117.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 134.5,
    cy: 150.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 35.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 51.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 68.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 84.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 101.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 117.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 134.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 150.5,
    cy: 150.5,
    r: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.2a4b01a5e99eca2ef42735c673791b16.svg";
export { ForwardRef as ReactComponent };